import green from "@material-ui/core/colors/green"
const styles = theme => ({
  selected: {
    fontWeight: "600",
  },
  unselected: {
    color: "grey",
  },
  picker: {
    width: 325,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  card: {
    overflow: "initial",
    marginBottom: theme.spacing(2),
    "&:last-of-type": {
      marginBottom: 0,
    },
  },
  additionalGearWrapper: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  inputWrapper: {
    display: "flex",
    alignItems: "baseline",
    marginBottom: theme.spacing(1),
  },
  autoComplete: {
    flexGrow: 1,
  },
  marginRight: {
    marginRight: theme.spacing(1),
  },
  locationAutoComplete: {
    marginTop: 16,
  },
  saveButton: {
    position: "fixed",
    bottom: 32,
    right: 32,
  },
  closeIcon: {
    color: theme.palette.primary.main,
    backgroundColor: "white",
  },
  closeAvatar: {
    backgroundColor: "white",
    border: `2px solid ${theme.palette.primary.main}`,
    cursor: "pointer",
  },
  chipYellow: {
    backgroundColor: "#FFB60C",
    cursor: "pointer",
  },
  chipGreen: {
    backgroundColor: green[400],
    cursor: "pointer",
  },
  chipRed: {
    backgroundColor: theme.palette.secondary.main,
    cursor: "pointer",
  },
  detailTypography: {
    marginBottom: theme.spacing(1),
  },
  detailWrapper: {
    marginBottom: theme.spacing(2),
  },
  mapImage: {
    width: "100%",
  },
  location: {
    display: "flex",
    alignItems: "center",
    overflow: "hidden",
  },
  placeName: {
    fontSize: 10,
    display: "inline-block",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  placeIcon: {
    width: "0.7em",
    marginLeft: -2,
    marginRight: theme.spacing(1),
  },
  rateWrapper: {
    flexGrow: 1,
    // textAlign: "right",
    display: "flex",
    // justifyContent: "flex-end",
    alignItems: "baseline",
  },
  rateHeadline: {
    color: "grey",
    fontSize: "0.7rem",
    // fontFamily: "Oswald",
  },
  rate: {
    // color: "grey",
    // fontFamily: "Oswald",
  },
})

export default styles
